import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from "./types";
const ALIGN_CENTER = "center";
const SETTINGS_TAB = {
  SETTINGS: "SETTINGS",
  DESIGN: "DESIGN"
};
const DEFAULT_CONFIG = {
  alignment: ALIGN_CENTER,
  size: "small",
  width: "fit-content"
};
const buttonsModals = {
  settings: {
    [ACTION_BUTTON_TYPE]: `${Node_Type.BUTTON}.actionButtonSettings`,
    [LINK_BUTTON_TYPE]: `${Node_Type.BUTTON}.linkButtonSettings`
  },
  alignment: {
    [ACTION_BUTTON_TYPE]: `${Node_Type.BUTTON}.actionButtonAlignment`,
    [LINK_BUTTON_TYPE]: `${Node_Type.BUTTON}.linkButtonAlignment`
  },
  colorPicker: `${Node_Type.BUTTON}.colorPicker`
};
const BUTTONS_TYPE_TO_TIPTAP_ATTR = {
  [ACTION_BUTTON_TYPE]: "ACTION",
  [LINK_BUTTON_TYPE]: "LINK"
};
export {
  BUTTONS_TYPE_TO_TIPTAP_ATTR,
  DEFAULT_CONFIG,
  SETTINGS_TAB,
  buttonsModals
};
//# sourceMappingURL=constants.js.map
